import { useEffect, useRef, useState } from 'react';
import { getToken } from 'src/utils/Common';
import axios from 'src/utils/axiosStatus';
import axiosTech from 'src/utils/axios'

const useOnlineStatus = (intervalTime = 15000) => {
    const [isOnline, setIsOnline] = useState(true);
    const [isOnlineModeActive, setIsOnlineModeActive] = useState(false);
    const offlineCountRef = useRef(0);
    const offlineThreshold = 3;

    const apiUrl = process.env.REACT_APP_API_URL;

    const authToken = getToken();


    let logItemsToSync = ["repairCompletedLogs", 'statusLogs'];


    useEffect(() => {
        if (!isOnlineModeActive || !('serviceWorker' in navigator)) {
            return;
        }

        let interval = null;
        let started = false;

        const checkStatus = () => {
            // Sekme/uygulama arka plandayken health-check gönderme; arka plan
            // throttling'i yanlış-pozitif "offline" tespitine yol açıyordu.
            if (document.hidden) {
                return;
            }
            if (navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({ type: 'CHECK_ONLINE_STATUS', apiUrl, authToken });
            }
        };

        const handleMessage = (event) => {
            if (event.data && typeof event.data.online === 'boolean') {
                if (event.data.online) {
                    offlineCountRef.current = 0;
                    setIsOnline(true);
                    // syncStatusLogs();
                    syncLogs();
                    return;
                }

                offlineCountRef.current += 1;
                if (offlineCountRef.current >= offlineThreshold) {
                    setIsOnline(false);
                }
            }
        };

        const startMonitoring = () => {
            if (!navigator.serviceWorker.controller || started) {
                return;
            }
            started = true;
            navigator.serviceWorker.addEventListener('message', handleMessage);
            interval = setInterval(checkStatus, intervalTime);
            // İlk kontrolü hemen yap
            checkStatus();
        };

        const handleControllerChange = () => {
            startMonitoring();
        };

        // Sekme arka plandayken biriken sahte hata sayısı, tekrar görünür
        // olunduğunda offline'a düşürmesin diye sıfırlanıyor.
        const handleVisibilityChange = () => {
            if (document.hidden) {
                return;
            }
            offlineCountRef.current = 0;
            checkStatus();
        };

        startMonitoring();

        if (!started) {
            navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
            navigator.serviceWorker.ready.then(() => {
                startMonitoring();
            });
        }

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            if (interval) {
                clearInterval(interval);
            }
            if (started) {
                navigator.serviceWorker.removeEventListener('message', handleMessage);
            }
            navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };

    }, [apiUrl, intervalTime, isOnlineModeActive]);


    useEffect(() => {
        checkOnlineModeIsActive();
    }, [apiUrl])



    const syncStatusLogs = () => {
        const logs = JSON.parse(localStorage.getItem('statusLogs')) || [];

        if (logs.length > 0) {
            try {
                axios.post('/pushlogs', logs)
                    .then(response => {
                        if (response.status === 200) {
                            localStorage.removeItem('statusLogs');
                        }
                    })
            }
            catch (error) { }
        }
    }


    const syncLogs = () => {
        const logsToSend = logItemsToSync.map(logItem => {
            const items = JSON.parse(localStorage.getItem(logItem)) || {};
            if (!items || Object.keys(items).length === 0) {
                return null;
            }
            let stringfiedItems = JSON.stringify(items);
            return items ? { logItemName: logItem, items: stringfiedItems } : null;
        }).filter(log => log !== null);

        if (logsToSend.length > 0) {
            axios.post('/pushgenerallogs', logsToSend)
                .then(response => {
                    if (response.status === 200) {
                        logItemsToSync.forEach(logItem => localStorage.removeItem(logItem));
                    }
                })
                .catch(error => console.error("Log senkronizasyonu başarısız:", error));
        }
    }

    const checkOnlineModeIsActive = () => {
        try {
            axiosTech.get(`/GetDefinedValue/${14}`)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data?.Value === 1) {
                            setIsOnlineModeActive(true);
                        }
                    }
                })
        }
        catch (ex) {
            console.log(ex);
        }
    }

    return { isOnline, isOnlineModeActive };


}

export default useOnlineStatus;